import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { AssignmentType } from "@/types/assignments";

interface DeleteAssignmentInput {
  id: string;
  type: AssignmentType;
}

export function useDeleteAssignment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, type }: DeleteAssignmentInput) => {
      const table = type === "curriculum" ? "curriculum_assignments" : "course_assignments";
      
      const { error } = await supabase
        .from(table)
        .delete()
        .eq("id", id);

      if (error) {
        throw new Error(`Failed to delete assignment: ${error.message}`);
      }

      return { id, type };
    },
    onSuccess: () => {
      // Invalidate assignments queries to refresh the list
      queryClient.invalidateQueries({ queryKey: ["all_learning_assignments"] });
      queryClient.invalidateQueries({ queryKey: ["user_learning_assignments"] });
    },
  });
}
